import { Link } from "react-router-dom";
import type { OrderAnfrageLink, OrderHistoryRow } from "@/lib/orders";

function anfrageLinkLabel(link: OrderAnfrageLink): string {
  const taNums = [...new Set((link.ta_nummern || []).filter(Boolean))];
  if (taNums.length) return taNums.join(", ");
  const subject = (link.anfrage_subject || "").trim();
  if (subject) return subject;
  return `#${link.anfrage_id}`;
}

export function OrderSourceLinks({
  order,
  className = "eh-order-chip eh-order-chip--link",
  onNavigate,
}: {
  order: OrderHistoryRow;
  className?: string;
  onNavigate?: () => void;
}) {
  const anfrageLinks = order.anfrage_links || [];
  const hasMa = Boolean(order.source_ma?.id);
  if (!hasMa && !anfrageLinks.length) return null;

  return (
    <>
      {hasMa ? (
        <Link
          to={`/materialanforderungen?id=${order.source_ma!.id}`}
          className={className}
          onClick={(e) => {
            e.stopPropagation();
            onNavigate?.();
          }}
        >
          Aus MA {order.source_ma!.ma_nummer || `#${order.source_ma!.id}`}
        </Link>
      ) : null}
      {anfrageLinks.map((l) => (
        <Link
          key={l.anfrage_id}
          to={`/anfragen?id=${l.anfrage_id}`}
          className={className}
          onClick={(e) => {
            e.stopPropagation();
            onNavigate?.();
          }}
        >
          Aus TA {anfrageLinkLabel(l)}
        </Link>
      ))}
    </>
  );
}
